import { Button, Card, List, Typography } from 'antd';
import { styled } from 'styled-components';
import { blockStyle } from '../../../../../components/styles/Block';

const { Text } = Typography;

export const TranscriptionBlock = styled.div`
  ${blockStyle}
  position: relative;
`;

export const CenteredMessage = styled.div`
  text-align: center;
  padding: 40px 0;
`;

export const SpinnerMargin = styled.div`
  margin-top: 16px;
`;

export const StyledListItem = styled(List.Item)`
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const TranscriptRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const TimeCodeText = styled(Text)`
  color: #888;
  font-size: 12px;
  min-width: 50px;
`;

export const TimeCodeButton = styled(Button)`
  font-size: 12px;
  min-width: 50px;
  height: auto;
  padding: 0;
  justify-content: flex-start;
`;

export const Speaker = styled(Text)`
  font-weight: 600;
  font-size: 12px;
  min-width: 80px;
`;

export const TranscriptCard = styled(Card)`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex: 1;
    overflow-y: auto;
  }
`;
